export default __webpack_public_path__ + "static/media/video_white.e787b46a.svg";